module.exports = __webpack_public_path__ + "img/Generali.09ff9988.png";